export default __webpack_public_path__ + "static/media/picture4.236579ff.jpeg";